const FETCH_PG_CONFIG_REQUEST = 'FETCH_PG_CONFIG_REQUEST';
const FETCH_PG_CONFIG_SUCCESS = 'FETCH_PG_CONFIG_SUCCESS';
const FETCH_PG_CONFIG_ERROR = 'FETCH_PG_CONFIG_ERROR';
const SAVE_PG_DETAIL_REQUEST = 'SAVE_PG_DETAIL_REQUEST';
const SAVE_PG_DETAIL_SUCCESS = 'SAVE_PG_DETAIL_SUCCESS';
const SAVE_PG_DETAIL_ERROR = 'SAVE_PG_DETAIL_ERROR';
const UPDATE_PG_REQUEST = 'UPDATE_PG_REQUEST';
const UPDATE_PG_SUCCESS = 'UPDATE_PG_SUCCESS';
const UPDATE_PG_ERROR = 'UPDATE_PG_ERROR';
const UPDATE_PG_STATUS_REQUEST = 'UPDATE_PG_STATUS_REQUEST';
const UPDATE_PG_STATUS_SUCCESS = 'UPDATE_PG_STATUS_SUCCESS';
const UPDATE_PG_STATUS_ERROR = 'UPDATE_PG_STATUS_ERROR';
const RESET_SAVED_PGS = 'RESET_SAVED_PGS';

export {
    FETCH_PG_CONFIG_REQUEST,
    FETCH_PG_CONFIG_SUCCESS,
    FETCH_PG_CONFIG_ERROR,
    SAVE_PG_DETAIL_REQUEST,
    SAVE_PG_DETAIL_SUCCESS,
    SAVE_PG_DETAIL_ERROR,
    UPDATE_PG_REQUEST,
    UPDATE_PG_SUCCESS,
    UPDATE_PG_ERROR,
    UPDATE_PG_STATUS_REQUEST,
    UPDATE_PG_STATUS_SUCCESS,
    UPDATE_PG_STATUS_ERROR,
    RESET_SAVED_PGS,
};
